import React from 'react';
import { motion } from 'framer-motion';
import { useMetronome } from '../contexts/MetronomeContext';
import { useLanguage } from '../contexts/LanguageContext';

const NoteTypeSelector = () => {
  const { currentRhythmType, updateRhythmType, RHYTHM_TYPES } = useMetronome();
  const { t } = useLanguage();

  return (
    <div className="mb-4">
      <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {t('noteType')}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Object.values(RHYTHM_TYPES).map((rhythmType, index) => (
          <motion.button
            key={rhythmType.id}
            onClick={() => updateRhythmType(rhythmType.id)}
            className={`py-3 px-2 rounded-lg transition-all ${
              currentRhythmType.id === rhythmType.id
                ? 'bg-indigo-100 border-2 border-indigo-500 text-indigo-700 dark:bg-indigo-900/30 dark:border-indigo-500 dark:text-indigo-300'
                : 'bg-white border border-gray-200 text-gray-700 hover:border-gray-300 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-300 dark:hover:border-gray-500'
            }`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.03 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="text-sm font-medium">
              {t(`noteTypes.${rhythmType.id}`)}
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default NoteTypeSelector;